import { Badge } from 'react-bootstrap';
import styles from './BetaBadge.module.scss';

const BetaBadgeComponent = ({ big = false }) => {
  if (big)
    return (
      <span className={styles.largeBadge}>
        <Badge variant={'secondary'} className={'ml-2'}>
          Beta
        </Badge>
      </span>
    );

  return <Badge variant={'light'}>&beta;</Badge>;
};

export { BetaBadgeComponent as BetaBadge };
